export const PULSELEADS_LEAD_FOLLOW_UP_TITLE = "title.pulseleadsLead.followUp";
export const PULSELEADS_LEAD_FOLLOW_UP_MANUAL_UPDATE_TITLE = "title.pulseleadsLead.followUp.manualUpdate";

export const PULSELEADS_LEAD_FOLLOW_UP_PATH = "/follow-up";
export const PULSELEADS_LEAD_FOLLOW_UP_MANUAL_UPDATE_PATH = "/manual-update";

export const PULSELEADS_LEAD_FOLLOW_UP_MANUAL_UPDATE_NAMESPACE = "PULSELEADS-LEAD-FOLLOW-UP-MANUAL-UPDATE";